export default "__VITE_ASSET__B2N63pA___"